<template>
<el-main class="client-login-bg">
  <div class="client-login-container">
    <img class="client-login-logo" src="/static/logo.svg">
    <el-form :model="clientLogin" status-icon :rules="rules" ref="clientLogin" @submit.native.prevent>
      <el-form-item label="Ingresa tu contraseña" prop="password">
        <el-input type="password" placeholder="" prefix-icon="el-icon-edit" v-model="clientLogin.password" auto-complete="off" @keyup.enter.native="validateAndSumbit('clientLogin')"></el-input>
      </el-form-item>
      <el-button type="primary" v-on:click="validateAndSumbit('clientLogin')" style="width:100%; background-color:#2873DE; border:none">Ver mi portafolio</el-button>
    </el-form>
  </div>
</el-main>
</template>

<script>
import { getPortfolioByUrl } from '@/graphql'
export default {
  name: 'ClientLogin',
  mounted () {
    this.clientLogin.hash = this.$route.query.portafolio
  },
  data () {
    return {
      clientLogin: {
        password: '',
        hash: ''
      },
      rules: {
        password: [
          {
            required: true,
            message: "Debes proporcionar una contraseña",
            trigger: "blur"
          }
        ]
      }
    }
  },
  methods: {
    validateAndSumbit (formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.sendLoginRequest(this.clientLogin)
        } else {
          return false;
        }
      })
    },
    sendLoginRequest (data) {
      this.$apollo.query({
          query: getPortfolioByUrl,
          variables: {
            hash: data.hash,
            password: data.password
          },
        }).then((data) => this.successHandler(data.data.portfolioAnalysisByUrl)
        ).catch((error) => {
          this.$message({
            type: 'error',
            message: 'Ocurrió un error, intenta más tarde'
          })
        }
      )
    },
    successHandler (data) {
      if (data.analysisPortfolio) {
        const portfolioId = data.analysisPortfolio.portfolioId
        localStorage.setItem('portafolio_id', portfolioId)
        localStorage.setItem('client_token', this.clientLogin.hash)
        this.$store.dispatch("saveCurrentPortfolioAnalysis", data.analysisPortfolio)
        .then(this.$router.push(`/analisis-portafolio/${portfolioId}`))
      } else if (data.returnCode === 1) {
        this.$message({
          type: 'error',
          message: 'La constraseña es incorrecta'
        })
      }
    }
  }
}
</script>

<style scoped>
  .el-main {
    height: 100%;
  }

  .client-login-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    max-width: 300px;
    height: 100%;
    margin: auto;
  }

  .client-login-logo {
    height: 40px;
    width: 300px;
  }

  .el-form {
    margin: 40px 0;
  }

  .client-login-bg {
    background-image: url('/static/client-login-bg.jpg');
    background-size: auto;
    background-repeat: no-repeat;
    background-position-x: center;
    background-position-y: initial
  }
</style>



// WEBPACK FOOTER //
// src/components/ClientLogin.vue